





























































































































































































export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-question-answer/index.vue"
}
